import { Field } from 'react-final-form';
import React from 'react';

function getLenskartPrice(prices) {
    const lenskartPrice = prices.filter(p => p.name === 'Lenskart Price');
    return <span className="inline-block margin-l5">(&#8377;{lenskartPrice ? lenskartPrice[0].price : null})</span>;
}

const PackageGroup = ({ dataLocale, name, currentPackage, packages, callback }) => (
    <React.Fragment>
        <div className="form-group" style={{ fontWeight: 900, letterSpacing: '0.5px', fontSize: '14px' }}>{dataLocale.CURRENT_PACKAGE}: {currentPackage}</div>
        {packages.map(p => (
            <div className="form-group" key={p.id}>
                <label>
                    <Field name={name} component="input" type="radio" value={p.id} onClick={() => callback(p.name)} />
                    <span className="inline-block margin-l5">{p.name} {getLenskartPrice(p.prices)}</span>
                </label>
            </div>
        ))}
    </React.Fragment>
);

export default PackageGroup;
